import { render } from "./PostQualificationNotFound.html?vue&type=template&id=2762bb82&external"
import script from "./PostQualificationNotFound.vue?vue&type=script&lang=js"
export * from "./PostQualificationNotFound.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__